module.exports = __webpack_public_path__ + "img/data-storage1.2a5cdf4d.png";